import { Award, Factory, Target, Heart } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="bg-[#F9FAFB]" data-testid="about-page">
      <div className="relative py-24 bg-navy overflow-hidden">
        <div className="absolute inset-0 opacity-10"><div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 -translate-y-1/2" /></div>
        <div className="container-custom relative z-10">
          <h1 className="text-4xl md:text-6xl font-serif text-white mb-4 tracking-tight">About <span className="text-coir">Us</span></h1>
          <p className="text-white/70 text-xl font-sans max-w-2xl">Pioneering coconut fiber excellence since 2006 from Andhra Pradesh, India.</p>
        </div>
      </div>

      <div className="section-padding">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6 tracking-tight">Our <span className="text-forest">Story</span></h2>
              <p className="text-slate-600 text-lg mb-4 font-sans leading-relaxed">
                Founded in 2006, Sri Srinivasa Coir Industry began as a small coconut fiber processing unit
                in Andhra Pradesh. Over nearly two decades, we have grown into a leading manufacturer and
                exporter of premium coir products.
              </p>
              <p className="text-slate-500 mb-6 font-sans leading-relaxed">
                Our journey has been driven by a commitment to quality, sustainability, and innovation.
                Today, we serve customers across India and beyond, providing them with products that meet
                the highest international standards.
              </p>
              <div className="grid grid-cols-2 gap-4">
                {[{ icon: Target, title: "Our Mission", desc: "To be the most trusted name in coconut fiber products globally." }, { icon: Heart, title: "Our Values", desc: "Quality, sustainability, and customer satisfaction above all." }].map((item, i) => (
                  <div key={i} className="bg-white p-5 shadow-sm border border-slate-100">
                    <item.icon className="w-8 h-8 text-forest mb-3" />
                    <h4 className="font-serif text-navy mb-2 text-lg">{item.title}</h4>
                    <p className="text-slate-500 text-sm font-sans">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img src="https://images.unsplash.com/photo-1600279297442-fab4907d4773?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" alt="Coconut palms" className="shadow-2xl w-full h-[500px] object-cover" />
              <div className="absolute -bottom-6 -left-6 bg-coir text-white p-6 shadow-lg">
                <p className="text-4xl font-bold font-mono">19+</p>
                <p className="text-sm font-sans">Years of Excellence</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 mb-24">
            {[{ icon: Award, val: "19+", label: "Years Experience" }, { icon: Factory, val: "5+", label: "Products" }].map((s, i) => (
              <div key={i} className="bg-white text-center p-8 shadow-lg shadow-slate-100/50">
                <s.icon className="w-10 h-10 text-forest mx-auto mb-4" />
                <p className="text-4xl font-bold text-navy font-serif mb-2">{s.val}</p>
                <p className="text-slate-500 text-sm font-sans">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
